import { render, staticRenderFns } from "./TeamRank.vue?vue&type=template&id=4b2f4c00&"
import script from "./TeamRank.vue?vue&type=script&lang=js&"
export * from "./TeamRank.vue?vue&type=script&lang=js&"
import style0 from "./TeamRank.vue?vue&type=style&index=0&id=4b2f4c00&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports